(()=>{
  const script=document.currentScript;
  const searchPath=script?.dataset.searchUrl||'/search';
  const categoryHandles={
    salotto:{types:['Divani e Poltrone']},'tavoli-e-sedie':{types:['Tavoli','Sedie']},
    illuminazione:{types:['Lampade']},'mobili-e-storage':{types:['Mobili']},
    'oggetti-di-design':{types:['Accessori']},'my-desk':{query:'scrivania',label:'My desk'},
    'camera-da-letto':{query:'letto',label:'Camera da letto'},bagno:{query:'bagno',label:'Bagno'}
  };
  function catalogUrl(value){
    const url=new URL(value,location.origin);
    if(url.origin!==location.origin)return null;
    const collection=url.pathname.match(/^(.*?)\/collections\/([^/]+)\/?$/);
    if(collection){
      const handle=collection[2],category=categoryHandles[handle];
      if(!['all','disponibili'].includes(handle)&&!category)return null;
      const prefix=collection[1]||searchPath.replace(/\/search\/?$/,'');
      url.pathname=prefix+'/search';
      if(category?.types&&!url.searchParams.has('filter.p.product_type'))category.types.forEach(type=>url.searchParams.append('filter.p.product_type',type));
      if(!url.searchParams.get('q')?.trim())url.searchParams.set('q',category?.query||'*');
      if(category?.query&&url.searchParams.get('q')===category.query)url.searchParams.set('vr_category',handle);
    }else if(!/\/search\/?$/.test(url.pathname))return null;
    url.searchParams.set('type','product');
    if(!url.searchParams.get('q')?.trim())url.searchParams.set('q','*');
    if(!url.searchParams.has('options[prefix]'))url.searchParams.set('options[prefix]','last');
    return url;
  }
  const current=new URL(location.href),canonical=catalogUrl(current);
  // No alternate collection page is painted for legacy category/catalog URLs.
  if(canonical&&!current.searchParams.has('section_id')&&canonical.href!==current.href){
    window.VRCatalogNavigationRedirecting=true;location.replace(canonical.href);return;
  }
  const init=()=>{
    function rewriteLinks(root=document){
      root.querySelectorAll('a[href]').forEach(link=>{
        if(link.closest('facet-remove,facet-filters-form,.pagination'))return;
        const url=catalogUrl(link.href);
        if(url){
          // These categories use a text criterion. Keep its navigation label distinct from a typed query.
          const category=Object.entries(categoryHandles).find(([handle,c])=>c.query===url.searchParams.get('q')&&c.label?.toLowerCase()===link.textContent.trim().toLowerCase());
          if(category)url.searchParams.set('vr_category',category[0]);
          if(link.href!==url.href)link.href=url.href;
        }
      });
    }
    function syncResultsTitle(){
      const title=document.querySelector('.vr-search-results-title');if(!title)return;
      const params=new URL(location.href).searchParams,query=(params.get('q')||'').trim();
      const category=categoryHandles[params.get('vr_category')];
      const types=[...new Set(params.getAll('filter.p.product_type'))].sort();
      const labels={'Divani e Poltrone':'Salotto','Sedie|Tavoli':'Tavoli e sedie',Lampade:'Illuminazione',Mobili:'Mobili e storage',Accessori:'Oggetti di design'};
      let text=query&&query!=='*'?query:(labels[types.join('|')]||types.join(', ')||'Catalogo');
      if(category?.query===query&&category.label)text=category.label;
      if(text==='Catalogo'&&document.documentElement.lang!=='it')text='Catalogue';
      if(title.textContent!==text)title.textContent=text;
      const marker=category?.query===query&&category.label?params.get('vr_category'):null;
      document.querySelectorAll('facet-filters-form form').forEach(form=>{
        let input=form.querySelector('input[name="vr_category"]');
        if(!marker){input?.remove();return;}
        if(!input){input=document.createElement('input');input.type='hidden';input.name='vr_category';form.append(input);}
        if(input.value!==marker)input.value=marker;
      });
      document.querySelectorAll('.pagination a,facet-remove a').forEach(link=>{
        const url=new URL(link.href,location.origin);
        if(marker&&url.searchParams.get('q')===query&&!url.searchParams.has('vr_category')){url.searchParams.set('vr_category',marker);link.href=url.href;}
      });
    }
    const sync=()=>{
      syncResultsTitle();
      rewriteLinks();
      const source=document.querySelector('#ProductCount');
      if(source){const text=source.textContent.trim();document.querySelectorAll('.vr-search-inline-count').forEach(n=>{if(n.textContent.trim()!==text)n.textContent=text;});}
    };
    document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(!link||link.closest('facet-remove,facet-filters-form,.pagination'))return;const url=catalogUrl(link.href);if(url)link.href=url.href;},true);
    document.addEventListener('submit',event=>{
      const form=event.target;if(!(form instanceof HTMLFormElement))return;
      const input=form.querySelector('input[name="q"]');
      if(!input||!form.matches('form[role="search"],.vr-hero-search,.vr-catalog-search,.vr-mobile-catalog-search form'))return;
      // A newly typed search starts without the previous filters or sorting.
      form.querySelectorAll('input[type="hidden"]').forEach(n=>{if(n.name.startsWith('filter.')||['vr_availability','sort_by','page'].includes(n.name))n.remove();});
      form.querySelectorAll('input[name="vr_category"]').forEach(n=>n.remove());
      form.action=searchPath;
      if(!input.value.trim())input.value='*';
      if(!form.querySelector('[name="type"]')){const type=document.createElement('input');type.type='hidden';type.name='type';type.value='product';form.append(type);}
    },true);
    let queued=false;
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
    const main=document.querySelector('#MainContent');if(main)new MutationObserver(schedule).observe(main,{childList:true,subtree:true});
    window.addEventListener('popstate',schedule);sync();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
